import script from "./PersonalInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfoCard.vue?vue&type=style&index=0&id=518d3745&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-518d3745"]])

export default __exports__